import { RulesCategoryLocData, RulesCategoryThemeData, RulesItemLocData, TextureData } from "../../../types/types";
import { AppSettings } from "../../managers/AppSettings";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { ScrollPaneTitledListContent } from "../dealcomplete/ScrollPaneTitledListContent";
import { RulesListItem } from "./RulesListItem";
import { AppObjectPool } from "../../pooling/AppObjectPool";
import { LayoutDataManager } from "../../managers/LayoutDataManager";


export enum RulesItemType {
    PARAGRAPH = "p",
    HEADER1 = "h01",
    HEADER2 = "h02",
}

export class RulesCategoryContent
    extends ScrollPaneTitledListContent {
    private locData: RulesCategoryLocData;

    // shared btwn categories = static.
    private static itemBgTextureData: TextureData = {
        texture: LoaderFileKeys.ui,
        // frame:"rect-2x2-black-A40.png",
        frame: "rect-2x2-transparent.png",
    };
    private itemStyleH1: Phaser.Types.GameObjects.Text.TextStyle;
    private itemStyleH2: Phaser.Types.GameObjects.Text.TextStyle;
    private itemStyleP: Phaser.Types.GameObjects.Text.TextStyle;

    public override Init(
        // locData?: RulesCategoryLocData,
        // themeData?: RulesCategoryThemeData
    ): void {
        // > items
        super.Init();

        var rulesStyles = LayoutDataManager.GetSharedData().rules.styles;
        this.itemStyleH1 = {
            color: AppSettings.colors.whiteString,
            padding: rulesStyles.h1.padding,
            align: "left",
            fontSize: rulesStyles.h1.fontSize,
            fontFamily: AppSettings.fontFamilies.MontserratBold,
            metrics: AppSettings.metrics.montserratBold60,
        };
        this.itemStyleH2 = {
            color: AppSettings.colors.whiteString,
            padding: rulesStyles.h2.padding,
            align: "left",
            fontSize: rulesStyles.h2.fontSize,
            fontFamily: AppSettings.fontFamilies.MontserratBold,
            metrics: AppSettings.metrics.montserratBold45,
        };
        this.itemStyleP = {
            color: AppSettings.colors.whiteString,
            padding: rulesStyles.p.padding,
            align: "left",
            fontSize: rulesStyles.p.fontSize,
            fontFamily: AppSettings.fontFamilies.MontserratMedium,
            metrics: AppSettings.metrics.montserratMedium40,
            lineSpacing: rulesStyles.p.lineSpacing,
        };

        // this.categoryData = categoryData;
        // this.locData = locData;
        // this.nodeTheme = themeData;
    }

    /**
     * Create list items from data set via @see Init
     */
    public Build(): void {
        // > build title (needs this.nodeTheme)
        super.Build();
        this.add(this.nsContentBg);

        // this.locData.items.forEach((itemLocData: RulesItemLocData, i: number) => {
        //     // + Init + Build
        //     const rulesItem: RulesListItem = this.GetFromPoolOrNew(itemLocData.type);
        //     this.items.push(rulesItem as any);
        //     this.add(rulesItem);
        // });
        // this.UpdateFromLocalizationChange();
    }

    /**
     * NOTE: call this before RulesScreen::Show (call @see RulesScreen::SetData before @see RulesScreen::Show)
     *       and it will even call @see SetWidth after @see UpdateFromLocalizationChange
     *       (it will even update sizes and scroll)
     * @param locData 
     * @param themeData 
     */
    public SetData(
        locData: RulesCategoryLocData,
        themeData: RulesCategoryThemeData,
    ): void {
        // console.log("SetData");

        this.locData = locData;
        this.nodeTheme = themeData;
        this.UpdateIcon();

        // update view
        // first, pool all items (because item.itemType/order might change from new data)
        this.poolItems();

        // next grab from pool by type (based on new model)
        this.locData.items.forEach((itemLocData: RulesItemLocData, i: number) => {
            const rulesItem: RulesListItem = this.GetFromPoolOrNew(itemLocData.type);
            this.items.push(rulesItem as any);
            this.add(rulesItem);
        });
        this.sendToBack(this.nsContentBg);

        // update view
        this.UpdateFromLocalizationChange();
    }

    protected GetFromPoolOrNew(itemType: string): RulesListItem {
        let item: RulesListItem = AppObjectPool.PickObject("RulesListItem_" + itemType); // keep style by using diff. pools
        if (item == null) {
            // console.log("itemType:", itemType);
            const itemLabelStyle: Phaser.Types.GameObjects.Text.TextStyle = this.GetTextStyleForItemType(itemType);
            item = new RulesListItem(this.scene);
            item.Init(RulesCategoryContent.itemBgTextureData, itemLabelStyle, itemType);
            item.Build();
        }
        return item;
    }

    /**
     * Used locally and from parent when pooling parent
     */
    poolItems() {
        while (this.items.length) {
            const removedItem: RulesListItem = this.items.pop() as unknown as RulesListItem;
            AppObjectPool.DropObject(removedItem, "RulesListItem_" + removedItem.itemType);
        }
    }

    /**
     * NOTE: call 
     */
    public UpdateFromLocalizationChange(): void {
        // category title
        const sTitle: string = this.locData.title.itemLabel;
        this.btnTitle.SetLabel(sTitle);

        // items
        (this.items as any as RulesListItem[]).forEach((rulesItem: RulesListItem, i: number) => {
            const itemLabel: string = this.locData.items[i].content;
            rulesItem.SetData(itemLabel);
        });
    }

    public override SetWidth(width: number): void {
        super.SetWidth(width);

        // add some space after last paragraph
        this.size.height += 40;
        // Also: extend last item's bg, so that it's bg covers a bit more space after the last paragraph
        this.items[this.items.length - 1].bg.displayHeight += 40;

        this.RedrawBorder();
    }

    private GetTextStyleForItemType(itemType: string): Phaser.Types.GameObjects.Text.TextStyle {
        switch (itemType as RulesItemType) {
            case RulesItemType.HEADER1:
                return this.itemStyleH1;

            case RulesItemType.HEADER2:
                return this.itemStyleH2;

            case RulesItemType.PARAGRAPH:
                return this.itemStyleP;
        }
    }
}